import axios from "axios";

export const getDashboardDetails = () => {
    return axios.get(`dashboard/data`).then( 
      (res) => { return { status: true, data: res.data.data, setting: res.data.setting}} , 
      (error) => { return { status: false, description: (!error.response.data)?"Something went wrong.": error.response.data.description } }
    )
}